import { useClerkEnvironment } from './useClerkEnvironment'
import { useMemo } from 'react'

export const useClerkSocialLogins = () => {
  const { userSettings } = useClerkEnvironment() as any
  return useMemo(
    () =>
      Object.values((userSettings?.social || {}) as Record<string, any>)
        .filter((provider) => provider.enabled && provider.authenticatable)
        .map((provider) => ({
          ...provider,
          logo_url: provider.logo_url && provider.logo_url.replace(/\.png$/, '.svg')
        })),
    [userSettings]
  )
}
